/* 
  This object contains the name and the fields of the steps in the 
  multi-part create project form.

  We use it to determine which fields should be validated
  when user clicks the 'Volgende' (next step) button.
*/
export const steps = {
  0: {
    name: 'naam',
    fields: ['firstname', 'insertion', 'lastname'],
  },
  1: {
    name: 'contactgegevens',
    fields: ['email', 'countryCode', 'mobilePhone'],
  },
  2: {
    name: 'locatie',
    fields: ['streetname', 'housenumber', 'zipcode', 'city'],
  },
  3: {
    name: 'klus',
    fields: ['title', 'description'],
  },
};